const tipDirective = {
  beforeMount(el, binding) {
    let tooltip

    const showTooltip = () => {
      if (tooltip) return

      tooltip = document.createElement("div")
      tooltip.textContent = binding.value.text || binding.value
      tooltip.style.position = "absolute"
      tooltip.style.backgroundColor = binding.value.bgColor || "#333"
      tooltip.style.color = binding.value.textColor || "#fff"
      tooltip.style.padding = "5px"
      tooltip.style.borderRadius = "4px"
      tooltip.style.whiteSpace = "nowrap"
      tooltip.style.zIndex = "1000"
      tooltip.style.transition = "opacity 0.2s"
      tooltip.style.opacity = "0"
      document.body.appendChild(tooltip)

      const hoveredElemBoundingRect = el.getBoundingClientRect()
      const tooltipRect = tooltip.getBoundingClientRect()

      let top =
        hoveredElemBoundingRect.top + window.scrollY - tooltipRect.height - 10
      let left =
        hoveredElemBoundingRect.left +
        window.scrollX +
        hoveredElemBoundingRect.width / 2 -
        tooltipRect.width / 2

      if (top < 0) {
        top = hoveredElemBoundingRect.bottom + window.scrollY + 10
      }
      if (left < 0) {
        left = 10
      }
      if (left + tooltipRect.width > window.innerWidth) {
        left = window.innerWidth - tooltipRect.width - 10
      }

      tooltip.style.top = `${top}px`
      tooltip.style.left = `${left}px`
      tooltip.style.opacity = "1"

      const handleClickOutside = (event) => {
        if (!el.contains(event.target) && tooltip) {
          hideTooltip()
          document.removeEventListener("click", handleClickOutside)
        }
      }

      document.addEventListener("click", handleClickOutside)
    }

    const hideTooltip = () => {
      if (tooltip) {
        tooltip.style.opacity = "0"
        setTimeout(() => {
          if (tooltip) {
            document.body.removeChild(tooltip)
            tooltip = null
          }
        }, 200)
      }
    }

    el.addEventListener("click", showTooltip)
    el.addEventListener("mouseleave", hideTooltip)
  }
}

export default tipDirective
